import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class ServiceCookie {
  constructor(private cookieService: CookieService) {}

  setData(key, value): void {
    // Set a cookie with a key, value, and optional expiration time
    this.cookieService.set(key, value, { expires: 7, path: '/' });
  }

  getData(key){
    // Get a cookie by key
    return this.cookieService.get(key);
  }

  removeData(key): void {
    // Remove a cookie by key
    this.cookieService.delete(key, '/');
  }

  clearAllData(): void {
    // Remove all cookies
    this.cookieService.deleteAll('/');
  }
}
